import { useBlocker } from "@tanstack/react-router";
import isEmpty from "lodash/isEmpty";
import { useFormContext } from "react-hook-form";

import { t } from "@/i18n-js/instance";

export interface PreventAccidentalLeaveProps {
  message?: string;
}

export const PreventAccidentalLeave = ({
  message,
}: PreventAccidentalLeaveProps) => {
  const {
    formState: { dirtyFields, isSubmitSuccessful },
  } = useFormContext();
  const shouldWarnLeave = !isEmpty(dirtyFields) && !isSubmitSuccessful;
  const warnMessage = message || t("prevent_accidental_leave_message");

  useBlocker({
    shouldBlockFn: () => shouldWarnLeave && !window.confirm(warnMessage),
    enableBeforeUnload: () => shouldWarnLeave,
  });

  return null;
};
